import { styled, lighten, darken } from "@mui/system";

export const tabProps = {
  textcolor: "secondary",
  indicatorColor: "secondary",
  sx: {
    width: "100%",
    overflow: "hidden",
    backgroundColor: "background.paper",
    "& .MuiTabs-scroller": {
      padding: "1px",
      marginTop: "5px",
      backgroundColor: "background.paper",
      borderBottom: 1,
      borderColor: "divider",
    },
    "& .MuiTab-root.MuiButtonBase-root ": {
      minHeight: "20px",
      padding: "8px 10px",
      minWidth: "70px",
    },
    "& .right ": {
      display: "inline-block",
      float: "right",
      marginLeft: "200px",
      fontWeight: "bold",

      span: {
        fontWeight: "400",
        cursor: "pointer",
      },
    },
  },
};

export const smallInputField = {
  style: { fontSize: "0.875rem", height: "24px" },
};
export const SCMTabProps = {
  textcolor: "secondary",
  indicatorColor: "secondary",
  sx: {
    width: "100%",
    overflow: "hidden",
    "& .MuiTabs-scroller": {
      padding: "1px",
      marginTop: "5px",
    },
    "& .MuiTab-root.MuiButtonBase-root ": {
      minHeight: "20px",
      padding: "8px 5px",
      minWidth: "70px",
    },
    "& .right ": {
      display: "inline-block",
      float: "right",
      marginLeft: "200px",
      fontWeight: "bold",

      span: {
        fontWeight: "400",
        cursor: "pointer",
      },
    },
  },
};

export const GridStyle = {
  "&.MuiGrid-item": { p: "0px 0px 0px 0px" },
};

export const designTabBoxProps = {
  sx: {
    mb: 0.5,
    p: 1,
    pt: 1,
    pb: 1,
    borderRadius: "8px",
    boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
    backgroundColor: "background.paper",
    border: 1,
    borderColor: "divider",
  },
};

export const tabScrollerProps = {
  sx: {
    borderBottom: 1,
    borderColor: "divider",
    "& .MuiTabs-root": {
      minHeight: "20px",
    },
    "& .MuiTab-root.MuiButtonBase-root ": {
      minHeight: "20px",
    },
  },
};

export const drawingSelectorStyle = {
  sx: {
    padding: "0px 5px",
    mb: 2,
    alignItems: "center",
    justifyContent: "center",
  },
};

export const GroupHeader = styled("div")(({ theme }) => ({
  position: "sticky",
  top: "-8px",
  padding: "4px 10px",
  color: theme.palette.primary.main,
  backgroundColor:
    theme.palette.mode === "light"
      ? lighten(theme.palette.primary.light, 0.85)
      : darken(theme.palette.primary.main, 0.8),
}));
export const GroupSubHeader = styled("div")(({ theme }) => ({
  position: "sticky",
  top: "-8px",
  padding: "4px 10px",
  color: theme.palette.primary.main,
  backgroundColor:
    theme.palette.mode === "light"
      ? lighten(theme.palette.primary.light, 0.95)
      : darken(theme.palette.primary.main, 0.9),
}));

export const GroupItems = styled("ul")({
  padding: 0,
});

// export const tableProps = {
//     muiTableHeadCellProps: {
//         sx: {
//             borderRight: '1px solid rgba(224,224,224,1)',
//             borderTop: '1px solid rgba(224,224,224,1)',
//             "& .Mui-TableHeadCell-Content-Wrapper": {
//                 whiteSpace: "normal",
//                 justifyContent: "center",
//                 marginBottom: "0.4px"
//             },
//             fontSize: "0.7rem",
//             verticalAlign: "middle",
//             height: "80px"
//         }
//     },
//     muiTableProps: {
//         size: "small",
//         sx: {
//             "& .MuiInputBase-root": {
//                 fontSize: '0.7rem',
//                 borderRadius: 0,

//             },
//             "& .MuiButtonBase-root": {
//                 fontSize: '0.7rem'
//             },

//         }
//     },
//     muiBottomToolbarProps: {
//         sx: {
//             // padding: "0rem",
//             "& .css-1llu0od": {
//                 padding: "0rem 0.5rem",

//             }
//         }
//     },
//     muiTableBodyCellProps: {
//         sx: {
//             borderRight: '1px solid rgba(224,224,224,1)',
//             padding: "0rem",
//             paddingLeft: "5px",
//             height: "36.4px"
//         },
//     },
//     initialState: { density: 'compact' }
// }

export const smallerHeadCellProps = {
  muiTableHeadCellProps: {
    sx: {
      borderRight: "1px solid rgba(224,224,224,1)",
      borderTop: "1px solid rgba(224,224,224,1)",
      "& .Mui-TableHeadCell-Content-Wrapper": {
        whiteSpace: "normal",
        justifyContent: "center",
        marginBottom: "0.4px",
      },
      // fontSize: "0.7rem",
      verticalAlign: "middle",
      height: "64.5px",
      padding: "2px",
      backgroundColor: "hsla(250, 86%, 97%, 1)",
      fontSize: "16px",
      textAlign: "center",
      // pt: 2,
    },
  },
};

export const compactTableProps = {
  muiTableHeadCellProps: {
    sx: {
      borderRight: "1px solid rgba(224,224,224,1)",
      borderTop: "1px solid rgba(224,224,224,1)",
      "& .Mui-TableHeadCell-Content-Wrapper": {
        whiteSpace: "normal",
        justifyContent: "center",
        marginBottom: "0.4px",
      },
      fontSize: "0.7rem",
      verticalAlign: "middle",
      height: "95px",
      padding: "2px",
    },
  },
  muiTableProps: {
    size: "small",
    sx: {
      "& .MuiInputBase-root": {
        fontSize: "0.7rem",
        borderRadius: 0,
      },
      "& .MuiButtonBase-root": {
        fontSize: "0.7rem",
      },
      "& .MuiTableCell-root": {
        fontSize: "0.7rem",
      },
    },
  },
  muiTableBodyCellProps: {
    sx: {
      textAlign: "center",
      borderRight: "1px solid #ddd",
      padding: "0rem",
      height: "33.1px",
    },
  },
  muiBottomToolbarProps: {
    sx: {
      "& .css-1llu0od": {
        padding: "0rem 0.5rem",
      },
    },
  },
  initialState: { density: "compact" },
};

export const greyTable = {
  muiTableBodyCellProps: {
    sx: {
      textAlign: "center",
      borderRight: "1px solid #ddd",
      padding: "0rem",
      height: "33.1px",
      backgroundColor: "#F5F5F5",
    },
  },
};

export const unborderedTableProps = {
  muiTableHeadCellProps: {
    sx: {
      "& .Mui-TableHeadCell-Content-Wrapper": {
        whiteSpace: "normal",
        justifyContent: "center",
        marginBottom: "0.4px",
      },
      fontSize: "0.7rem",
      verticalAlign: "middle",
      height: "95px",
      padding: "2px",
    },
  },
  muiTableBodyCellProps: {
    sx: {
      padding: "0rem",
      height: "33.1px",
    },
  },
};

export const normalTableProps = {
  muiTableHeadCellProps: {
    sx: {
      borderRight: "1px solid rgba(224,224,224,1)",
      borderTop: "1px solid rgba(224,224,224,1)",
      "& .Mui-TableHeadCell-Content-Wrapper": {
        whiteSpace: "normal",
        justifyContent: "center",
        // marginBottom: "0.4px"
      },
      fontSize: "0.8rem",
      verticalAlign: "middle",
    },
  },
  muiTableProps: {
    size: "small",
    sx: {
      "& .MuiInputBase-root": {
        fontSize: "0.8rem",
        borderRadius: 0,
      },
      "& .MuiButtonBase-root": {
        fontSize: "0.8rem",
      },
      "& .MuiTableCell-root": {
        fontSize: "0.8rem",
      },
    },
  },
  muiTableBodyCellProps: {
    sx: {
      height: "32.4px",
    },
  },
  // initialState: { density: 'compact' }
};

export const mcstableProps = {
  muiTableHeadCellProps: {
    sx: {
      borderRight: "1px solid rgba(224,224,224,1)",
      "& .Mui-TableHeadCell-Content-Wrapper": {
        whiteSpace: "normal",
        justifyContent: "center",
        // marginBottom: "0.4px"
      },
      fontSize: "0.7rem",
      verticalAlign: "middle",
    },
  },
  muiTableProps: {
    size: "small",
    sx: {
      "& .MuiInputBase-root": {
        fontSize: "0.7rem",
        borderRadius: 0,
      },
      "& .MuiButtonBase-root": {
        fontSize: "0.7rem",
      },
      "& .MuiTableCell-root": {
        fontSize: "0.7rem",
      },
    },
  },
  muiTableBodyCellProps: {
    sx: {
      padding: "0.5rem",
      height: "32.4px",
    },
  },
  // initialState: { density: 'compact' }
};

export const zeroElevationTableProps = {
  elevation: 0, //change the mui box shadow
  //customize paper styles
  sx: {
    borderRadius: "0",
    // border: '1px dashed #e0e0e0',
  },
};

export const tableWithBorderedCells = {
  muiTableBodyCellProps: {
    sx: {
      height: "32.4px",
      borderRight: 1,
      borderColor: "divider",
      backgroundColor: "background.paper",
    },
  },
};
export const verticalTabStyle = {
  sx: {
    borderRight: 1,
    // mt: 2,
    minWidth: "150px",
    width: "150px",
    borderColor: "divider",
    marginBottom: "10px",

    "& .MuiTab-root.MuiButtonBase-root": {
      marginTop: "10px",
    },
    "& .MuiTab-root.Mui-selected": {
      bgcolor: "action.selected",
    },
    textAlign: "left",
  },
};

export const fullPageBoxStyle = {
  sx: {
    width: "100%",
    minHeight: "85vh",
    overflow: "auto",
    position: "relative",
    bgcolor: "background.paper",
    borderTop: "0.5px solid transparent",
    boxSizing: "border-box",
    display: "flex",
    textAlign: "left",
    border: 1,
    borderColor: "divider",
    boxShadow: (theme) =>
      theme.palette.mode === "dark"
        ? "none"
        : "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
  },
};

export const linksUnstyled = {
  // textDecoration: 'none',
  color: "black",
};

export const bottomNavigationBoxStyle = {
  display: "flex",
  flexDirection: "row",
  width: "inherit",
  flexWrap: "wrap",
  alignItems: "end",
  pb: 2,
  pl: 2,
};

// Dashboard props
export const dashboardContainerProps = {
  sx: {
    borderRadius: "6px",
    backgroundColor: "#F8F8F8",
    width: "80vw",
    minHeight: "80vh",
    padding: 2,
  },
};

export const dashboardNumberCardBoxProps = {
  sx: {
    borderRadius: "6px",
    backgroundColor: "#F8F8F8",
    display: "flex",
    // flexDirection:"column"
  },
};

export const chartContainerProps = {
  width: 400,
  height: "fit-content",
  borderRadius: "6px",
  backgroundColor: "#FFFFFF",
  boxShadow:
    " 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)",
  pl: 4,
  // display: "flex",
  // alignItems: "center",
  mt: 2,
  ml: 4,
};

export const lightTable = {
  enableColumnActions: false,
  enableColumnFilters: false,
  enableTopToolbar: false,
  enableBottomToolbar: false,
  enablePagination: false,
  enableSorting: false,
  muiTableBodyRowProps: { hover: false },

  muiTableProps: {
    sx: {
      // border: '1px solid rgba(81, 81, 81, .5)',
      // caption: {
      //     captionSide: 'top',
      // },
    },
  },
  muiTableHeadCellProps: {
    sx: {
      border: "0.5px solid rgba(81, 81, 81, .1)",
      // fontStyle: 'italic',
      fontWeight: "normal",
      padding: "10px",
      backgroundColor: "#f3f1fe",
    },
  },
  muiTableBodyCellProps: {
    sx: {
      border: "1px solid rgba(81, 81, 81, .1)",
      padding: "10px",
    },
  },
  displayColumnDefOptions: {
    "mrt-row-select": {
      size: 10,
      minSize: 10,
      maxSize: 10,
      muiTableHeadCellProps: {
        align: "center",
        sx: {
          width: 10,
          padding: 0,
          textAlign: "center",
          border: "0.5px solid rgba(81, 81, 81, .1)",
          fontWeight: "normal",
          backgroundColor: "#f3f1fe",
        },
      },
      muiTableBodyCellProps: {
        sx: {
          width: 10,
          padding: 0,
          textAlign: "center",
        },
      },
    },
  },
};

export const tableProps = {
  muiTableHeadCellProps: {
    sx: {
      backgroundColor: "hsla(250, 86%, 97%, 1)",
      borderRight: "1px solid rgba(224,224,224,1)",
      borderTop: "1px solid rgba(224,224,224,1)",
      "& .Mui-TableHeadCell-Content-Wrapper": {
        whiteSpace: "normal",
        justifyContent: "center",
        marginBottom: "0.4px",
      },
      // fontSize: "0.675rem",
      fontSize: "12px",
      verticalAlign: "middle",
      height: "40.4px",
    },
  },
  muiTableProps: {
    size: "small",
    sx: {
      "& .MuiInputBase-root": {
        fontSize: "0.7rem",
        borderRadius: 0,
      },
      "& .MuiButtonBase-root": {
        fontSize: "0.7rem",
      },
    },
  },
  muiTableBodyCellProps: {
    sx: {
      borderRight: "1px solid rgba(224,224,224,1)",
      padding: "0rem",
      paddingLeft: "5px",
      // height: "30.4px"
    },
  },
};

export const minimalMuiTableProps = {
  // enableColumnActions: false,
  // enableColumnFilters: true,
  // columnFilterDisplayMode: "popover",
  // enablePagination: false,
  enableSorting: false,
  // enableBottomToolbar: false,
  // enableTopToolbar: true,
  // enableToolbarInternalActions: false,
  // muiTableBodyRowProps: { hover: false },
  muiTableProps: {
    sx: {
      border: 1,
      borderColor: "divider",
    },
  },
  muiTableBodyProps: {
    sx: {
      backgroundColor: "background.paper",
    },
  },
  muiTableHeadCellProps: {
    sx: {
      border: 1,
      borderColor: "divider",
      padding: 1,
      backgroundColor: (theme) =>
        theme.palette.mode === "dark"
          ? theme.palette.background.default
          : "#F3F2FD",
      // fontSize: "16px",
    },
  },
  muiBottomToolbarProps: {
    sx: {
      border: 1,
      borderColor: "divider",
      padding: 0,
      // backgroundColor: "#F8F9FAFF",
      // fontSize: "16px",
    },
  },
  muiTableBodyCellProps: {
    sx: {
      border: 1,
      borderColor: "divider",
      padding: 1,
      backgroundColor: "background.paper",
    },
  },
  muiTableFooterCellProps: {
    sx: {
      // border: "1px solid rgba(224,224,224,0.5)",
      padding: "5px",
    },
  },
  muiTablePaperProps: {
    elevation: 0,
    sx: {
      backgroundColor: "background.paper",
      border: 1,
      borderColor: "divider",
    },
  },
  muiTopToolbarProps: {
    sx: {
      backgroundColor: "background.paper",
      borderBottom: 1,
      borderColor: "divider",
      mb: 1,
    },
  },
};

export const greyedOutFields = {
  fontSize: "0.7rem",
  height: "18px",
  color: "black",
};

export const labelledBoxStyles = {
  backgroundColor: "bg.primary",
  borderRadius: "4px",
  display: "flex",
  flexDirection: "column",
  padding: 2,
  pt: 1,
  mb: 2,
  width: "max-content",
  border: "0.5px solid #d5d6db80",
  // boxShadow: "rgba(99, 99, 99, 0.05) 0px 2px 8px 0px;"
  // boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px"
  boxShadow:
    "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);",
};
